// utils/HTMLReportGenerator/ReportTreeView.js

import { ReportFilters } from "./ReportFilters.js";
import { ReportUtils } from "./ReportUtils.js";

export class ReportTreeView {
  /**
   * Générer la hiérarchie complète en treeview
   */
  static generateHierarchy(hierarchy) {
    const tiroirKeys = Object.keys(hierarchy).sort();

    if (tiroirKeys.length === 0) {
      return '<div class="no-issues">Aucune fibre à analyser</div>';
    }

    // Calculer les statistiques pour les filtres
    const filterStats = ReportUtils.calculateFilterStats(hierarchy);

    return `
      <div class="treeview-container">
        <h2>🌳 Analyse par structure</h2>
        
        ${ReportFilters.generateFiltersSection(filterStats)}
        
        <div class="tree" id="main-tree">
          ${tiroirKeys.map((tiroirKey) => this.generateTiroirNode(tiroirKey, hierarchy[tiroirKey])).join("")}
        </div>
      </div>
    `;
  }

  /**
   * Générer un nœud tiroir
   */
  static generateTiroirNode(tiroirKey, modules) {
    const moduleKeys = Object.keys(modules).sort();
    const tiroirStats = ReportUtils.calculateTiroirStats(modules);
    const statusClass = ReportUtils.getStatusClass(tiroirStats);

    return `
      <div class="tree-node tiroir-node ${statusClass}">
        <div class="tree-item tiroir-item" onclick="toggleNode(this)">
          <span class="tree-toggle">▼</span>
          <span class="tree-icon">📁</span>
          <span class="tree-label">Tiroir ${tiroirKey}</span>
          <span class="tree-stats">
            ${tiroirStats.total} fibres • 
            <span class="stat-ok">${tiroirStats.ok}</span> • 
            <span class="stat-warning">${tiroirStats.warnings}</span> • 
            <span class="stat-error">${tiroirStats.errors}</span>
          </span>
        </div>
        <div class="tree-children">
          ${moduleKeys.map((moduleKey) => this.generateModuleNode(moduleKey, modules[moduleKey])).join("")}
        </div>
      </div>
    `;
  }

  /**
   * Générer un nœud module
   */
  static generateModuleNode(moduleKey, fibers) {
    const moduleStats = ReportUtils.calculateModuleStats(fibers);
    const statusClass = ReportUtils.getStatusClass(moduleStats);

    return `
      <div class="tree-node module-node ${statusClass}">
        <div class="tree-item module-item" onclick="toggleNode(this)">
          <span class="tree-toggle">▼</span>
          <span class="tree-icon">📂</span>
          <span class="tree-label">Module ${moduleKey}</span>
          <span class="tree-stats">
            ${moduleStats.total} fibres • 
            <span class="stat-ok">${moduleStats.ok}</span> • 
            <span class="stat-warning">${moduleStats.warnings}</span> • 
            <span class="stat-error">${moduleStats.errors}</span>
          </span>
        </div>
        <div class="tree-children">
          ${fibers.map((fiber) => this.generateFiberNode(fiber)).join("")}
        </div>
      </div>
    `;
  }

  /**
   * Générer un nœud fibre
   */
  static generateFiberNode(fiber) {
    const effectiveStatus = ReportUtils.determineEffectiveStatus(fiber);
    const statusIcon = ReportUtils.getStatusIcon(effectiveStatus);
    const details = ReportUtils.generateFiberDetails(fiber);
    const compactReference = ReportUtils.generateCompactReference(fiber);
    const stateChip = ReportUtils.generateStateChip(fiber.etat);
    const bpoChip = ReportUtils.generateBpoChip(fiber.rop?.PBO_NORMALIZED);

    return `
      <div class="tree-node fiber-node ${effectiveStatus}">
        <div class="tree-item fiber-item ${effectiveStatus === "ok" ? "" : "clickable"}" ${effectiveStatus !== "ok" ? 'onclick="toggleNode(this)"' : ""}>
          ${effectiveStatus !== "ok" ? '<span class="tree-toggle">▼</span>' : '<span class="tree-spacer"></span>'}
          <span class="tree-icon">${statusIcon}</span>
          <span class="tree-label">${compactReference}</span>
          <span class="tree-meta">${stateChip}${bpoChip}</span>
        </div>
        ${
          effectiveStatus !== "ok"
            ? `
          <div class="tree-children">
            <div class="fiber-details">
              ${details}
            </div>
          </div>
        `
            : ""
        }
      </div>
    `;
  }

  /**
   * Générer le JavaScript pour la TreeView
   */
  static generateTreeViewJS() {
    return `
      function toggleNode(element) {
        const node = element.parentElement;
        const children = node.querySelector('.tree-children');
        const toggle = element.querySelector('.tree-toggle');
        
        if (children) {
          const isExpanded = children.style.display !== 'none';
          children.style.display = isExpanded ? 'none' : 'block';
          toggle.textContent = isExpanded ? '▶' : '▼';
          node.classList.toggle('collapsed', isExpanded);
        }
      }
      
      window.onload = function() {
        // Ouvrir tous les nœuds par défaut
        document.querySelectorAll('.tree-children').forEach(child => {
          child.style.display = 'block';
        });
        
        // Initialiser les filtres
        initializeFilters();
      };
    `;
  }
}
